// @flow

import logo from './logo.svg';
import './App.css';

import "@aws-amplify/ui-react/styles.css";
import {
  Authenticator, withAuthenticator, Heading, Image, View, Card
} from "@aws-amplify/ui-react";
import {Auth} from "aws-amplify";
import React, {useState, useEffect, lazy} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import AllRoutes from "./routes";
import OAuthPopup from './OAuth2/OAuthPopup';
import Home from './pages/Home';
import Permissions from "./pages/Permissions";
import TaxChatBot from "./pages/TaxChatBot";
import GetReport from "./pages/GetReport";
import Landing from "./pages/landing";
import AnimateButton from './Components/@extended/AnimateButton';
import { LogoutOutlined, LoginOutlined } from '@ant-design/icons';
import {Button, Tooltip} from '@mui/material';
import Subscribe from "./Components/Subscribe";

import {useDispatch, useSelector} from "react-redux";
import {handlerResetStore} from "./store/reducer/reset_store";
import {handlerSetAuthUser, handleSetUserAttributes, handlerSetLogIn} from "./store/reducer/authuser";

import Header from "./layout/MainLayout/Header";
import IconButton from "./Components/@extended/IconButton";
import UserProfile from "./pages/profiles/user";
import TabPersonal from "./sections/apps/profiles/user/TabPersonal";
import TabPayment from "./sections/apps/profiles/user/TabPayment";
import TabPassword from "./sections/apps/profiles/user/TabPassword";

import Snackbar from './Components/@extended/Snackbar';
import KanbanPage from "./pages/apps/kanban";
import Board from "./sections/apps/kanban/Board";
import Backlogs from "./sections/apps/kanban/Backlogs";
import Loadable from "./Components/Loadable";
import {getAuthPlan} from "./store/reducer/authuser"
import Footer from "./layout/Footer";

const AppKanban = Loadable(lazy(() => import('./pages/apps/kanban')));
const AppKanbanBacklogs = Loadable(lazy(() => import('./sections/apps/kanban/Backlogs')));
const AppKanbanBoard = Loadable(lazy(() => import ('./sections/apps/kanban/Board')));
const MaintenanceComingSoon = Loadable(lazy( () => import ('./pages/maintenance/coming-soon')));
const HomePage = Loadable(lazy( () => import ('./pages/Home')));
const UserProfilePage = Loadable(lazy( () => import ('./pages/profiles/user')));
const PersonalTab = Loadable(lazy( () => import ('./sections/apps/profiles/user/TabPersonal')));
const PasswordTab = Loadable(lazy( () => import ('./sections/apps/profiles/user/TabPassword')));
const PaymentTab = Loadable(lazy( () => import ('./sections/apps/profiles/user/TabPayment')));
const XeroIntegrationsTab = Loadable(lazy( () => import ('./sections/apps/profiles/user/XeroIntegrations')));
const AnalyticsPage = Loadable(lazy( () => import ('./pages/dashboard/analytics')));
const DashboardSummary = Loadable(lazy(() => import('./sections/apps/dashboard/Summary')));
const DashboardPayables = Loadable(lazy(() => import('./sections/apps/dashboard/Payables')));
const DashboardReceivables = Loadable(lazy(() => import('./sections/apps/dashboard/Receivables')));
const DashboardEmployees = Loadable(lazy(() => import('./sections/apps/dashboard/Employees')));
// const FAQPage = Loadable(lazy(() => import ('./pages/faq/faq')));
const ContactUs = Loadable(lazy( () => import('./pages/contact-us' )));
const PayablesDetails = Loadable(lazy(() => import('./pages/apps/payables/details')));

function LoginButton(props){
    console.log("Going to login")
    return (
        <>
            {/*<AnimateButton>*/}
            {/*    <Button size="large"*/}
            {/*            onClick={() => Auth.federatedSignIn({customProvider: "xero"})}*/}
            {/*            endIcon={<SendOutlined />}*/}
            {/*            variant="contained"*/}
            {/*    >Sign in with Xero*/}
            {/*    </Button>*/}
            {/*</AnimateButton>*/}
            <AnimateButton>
                <Button size="large"
                        onClick={() => Auth.federatedSignIn()}
                        endIcon={<LoginOutlined />}
                        variant="contained"
                >Sign in
                </Button>
            </AnimateButton>
        </>
    )
}

function LogoutButton(props){
    const dispatch = useDispatch();
    const handleLogOut = () => {
        dispatch(handlerResetStore({}));
        Auth.signOut()
    }

    return (
            // <AnimateButton>
            // <Button
            //     size="large"
            //     onClick={() => Auth.signOut()}
            //     endIcon={<LogoutOutlined />}
            //     variant="contained"
            // >Sign Out</Button>
            // </AnimateButton>

        <Tooltip title="Logout">
            <IconButton size="large" sx={{ color: 'text.primary' }} onClick={handleLogOut}>
                <LogoutOutlined />
            </IconButton>
        </Tooltip>

    )
}

function LogInComponent(props){
    return (
        <>
        <Landing LoginButton={<LoginButton />}></Landing>
        </>
            // <LoginButton></LoginButton>
    )
}

function LoggedInComponent(props){
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const { username } = useSelector( (state) => state.authuser)
    const user_name = props.user_name
    useEffect(() => {
        console.log("Logged In");
        const planName = dispatch(getAuthPlan(username));
        Promise.all([planName]).then((values => console.log(values)));
        const listenToScroll = () => {
          let heightToHideFrom = 250;
          const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

          if (winScroll > heightToHideFrom) {
            setVisible(true);
          } else {
            visible && setVisible(false);
          }
        };

        window.addEventListener('scroll', listenToScroll);
        return () => window.removeEventListener('scroll', listenToScroll);
      //   return function cleanup_xero_data(){
      //     setTokens({
      //         access_token: null,
      //         exp_time: null,
      //         refresh_token: null,
      //         tenantId: null
      //     })
      // }
    }, [visible, username]) //This empty array may need to be removed.

    return (
        <>

          {/*<Navbar bg="dark" variant="dark">*/}
        {/*<Container>*/}
        {/*  <Navbar.Brand href="/">Robo Tax</Navbar.Brand>*/}
        {/*  <Nav className="me-auto">*/}
        {/*    <Nav.Link href="/">Home</Nav.Link>*/}
        {/*      <Nav.Link href="/permissions">Permissions</Nav.Link>*/}
        {/*      <Nav.Link href="/getreport">Get Report</Nav.Link>*/}
        {/*      <Nav.Link href="/taxchatbot">Tax Chatbot</Nav.Link>*/}
        {/*      <Navbar.Text>{user_name}</Navbar.Text>*/}
        {/*      <Nav className="justify-content-end">*/}
        {/*          <LogoutButton></LogoutButton>*/}
        {/*      </Nav>*/}
        {/*  </Nav>*/}
        {/*</Container>*/}
          <Header LogoutButton={LogoutButton} />
            <Snackbar />
      {/*</Navbar>*/}
      {/*      <BrowserRouter>*/}
              <Routes>
                  <Route element={<OAuthPopup />} path="/callback" />
                  <Route element={<HomePage />} path='/'/> {/*Props may not be required*/}
                  {/*<Route element={<Permissions />} path='/permissions'/>*/}
                  {/*<Route element={<GetReport />} path='/getreport' />*/}
                  {/*<Route element={<TaxChatBot user_name={user_name}/>} path='/taxchatbot' />*/}
                  <Route element={<MaintenanceComingSoon />} path='/taxchatbot' />
                  <Route element={<AnalyticsPage />} path="/analytics/dashboard">
                      <Route path='summary' element={<DashboardSummary />} />
                      <Route path='payables' element={<DashboardPayables />} />
                      <Route path='receivables' element={<DashboardReceivables />} />
                      <Route path='employees' element={<DashboardEmployees />} />
                  </Route>
                  <Route element={<PayablesDetails />} path='invoice/details/:id' />
                  <Route element={<AppKanban />} path='/apps/kanban'>
                    <Route path='board' element={<AppKanbanBoard />} />
                    <Route path='backlogs' element={<AppKanbanBacklogs />} />
                  </Route>
                  {/*<Route element={<FAQPage />} path='/faq' />*/}
                  <Route element={<ContactUs />} path='/contact-us' />
                  <Route path='/profiles/user' element={<UserProfilePage />}>
                      <Route path='personal' element={<PersonalTab />} />
                      <Route path='payment' element={<PaymentTab />} />
                      <Route path='password' element={<PasswordTab />} />
                      <Route path='xero-integrations' element={<XeroIntegrationsTab />} />
                  </Route>
              </Routes>
          {/*</BrowserRouter>*/}
      <br />
        <Footer />
      {/*<View className="App">*/}
      {/*</View>*/}
          </>
    )
}

function App({signOut, user}) {
  // const [loggedIn, setLoggin] = useState(false);
  const loggedIn = useSelector((state) => {
      return state.authuser.loggedIn
  });
  const user_name = useSelector((state) => {
    return state.authuser.username
    });
    const dispatch = useDispatch();
    Auth.currentUserInfo().then(function(response){
            console.log(response)
            if ((JSON.stringify(response) === '{}') || (response === null)){
                console.log("Found null")
                // setLoggin(false)
                dispatch(
                    handlerSetLogIn({
                        loggedIn: false
                    })
                );
                dispatch(
                    handlerSetAuthUser({
                        username : ''
                    })
                );
                dispatch(
                    handleSetUserAttributes({
                        user_attributes: {}
                    })
                )
            } else {
                console.log("Found loggedin")
                // setLoggin(true)
                dispatch(
                    handlerSetLogIn({
                        loggedIn: true
                    })
                )
                dispatch(
                    handlerSetAuthUser({
                        username : response.attributes.email
                    })
                );
                dispatch(
                    handleSetUserAttributes({
                        user_attributes: response.attributes
                    })
                )
                // Auth.currentSession().then(res=>{
                //     let accessToken = res.getAccessToken();
                //     let jwt = accessToken.getJwtToken();
                //     console.log(`myAccessToken: ${JSON.stringify(accessToken)}`);
                //     console.log(`myJwt: ${jwt}`)
                //     handlerSetTokens({
                //         accessToken: accessToken,
                //         jwtToken: jwt
                //     })
                // })
                console.log("user: " + user)
            }
        }).catch(error => {
            console.log(error);
        })
    // determineLogin(loggedIn);
    // useEffect(() => {
    //     console.log(Auth.currentUserInfo())
    //     console.log("loggedIn" + loggedIn)
    //     determineLogin(loggedIn)
    //     // console.log(process.env.REACT_APP_CLIENT_ID)
    // }, [loggedIn, user_name])
  function determineLogin(props){
        // console.log("login: " + setLoggin(true))
        console.log("login: " + props.loggedIn)
        // Auth.currentUserInfo().then(function(response){
        //     console.log(response)
        //     if ((JSON.stringify(response) === '{}') || (response === null)){
        //         console.log("Found null")
        //         // setLoggin(false)
        //         dispatch(
        //             handlerSetLogIn({
        //                 loggedIn: false
        //             })
        //         );
        //         dispatch(
        //             handlerSetAuthUser({
        //                 username : ''
        //             })
        //         );
        //         dispatch(
        //             handleSetUserAttributes({
        //                 user_attributes: {}
        //             })
        //         )
        //     } else {
        //         console.log("Found loggedin")
        //         // setLoggin(true)
        //         dispatch(
        //             handlerSetLogIn({
        //                 loggedIn: true
        //             })
        //         )
        //         dispatch(
        //             handlerSetAuthUser({
        //                 username : response.attributes.email
        //             })
        //         );
        //         dispatch(
        //             handleSetUserAttributes({
        //                 user_attributes: response.attributes
        //             })
        //         )
        //         // Auth.currentSession().then(res=>{
        //         //     let accessToken = res.getAccessToken();
        //         //     let jwt = accessToken.getJwtToken();
        //         //     console.log(`myAccessToken: ${JSON.stringify(accessToken)}`);
        //         //     console.log(`myJwt: ${jwt}`)
        //         //     handlerSetTokens({
        //         //         accessToken: accessToken,
        //         //         jwtToken: jwt
        //         //     })
        //         // })
        //         console.log("user: " + user)
        //     }
        // }).catch(error => {
        //     console.log(error);
        // })
        console.log("login: " + loggedIn)
    }

  return (
      <>
          <AllRoutes />
          <Snackbar />
      </>
      // <>
      //   <style dangerouslySetInnerHTML={{__html: `
      //   @import url(/css/normalize.css);
      //   `}} />
      //   {loggedIn==false
      //   ? <LogInComponent></LogInComponent>
      //   : <LoggedInComponent user_name={user_name}></LoggedInComponent>}
      // </>
  );
}

export default App;
